import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ErrorService } from './error.service';
import { AuthConfigService } from './auth/auth-config.service';

@Injectable({
  providedIn: 'root'
})
export class StationService {
  public stations$ = new BehaviorSubject<string[]>([]);

  constructor(
    private httpClient: HttpClient,
    private errorService: ErrorService,
    private authConfig: AuthConfigService) {
  }

  public getStations() {
    this.httpClient
      .get<any>(this.authConfig.getConfig().dppApiUrl + 'dppservice/getStationList')
      .subscribe(
        res => this.stations$.next(res.stationList),
        err => this.errorService.setError(err)
      );
  }
}
